import { useState, type ReactNode } from "react";
import type { TaskWithFlags } from "@desk/contracts";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useTaskActions } from "@/data/actions";
import { CustomSnoozeDialog, SnoozePresetItems } from "@/features/snooze/SnoozeControls";

/** Wraps a concept-styled trigger in the task snooze menu (presets with resolved times, Custom…). */
export function TaskSnoozeMenu({ task, children }: { task: TaskWithFlags; children: ReactNode }) {
  const a = useTaskActions();
  const [custom, setCustom] = useState(false);
  return (
    <>
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild>{children}</DropdownMenuTrigger>
        <DropdownMenuContent align="start" onKeyDown={(e) => e.stopPropagation()}>
          <SnoozePresetItems onPick={(iso) => void a.snooze(task, iso)} onCustom={() => setCustom(true)} />
        </DropdownMenuContent>
      </DropdownMenu>
      <CustomSnoozeDialog open={custom} onOpenChange={setCustom} onConfirm={(iso) => void a.snooze(task, iso)} />
    </>
  );
}
